<div class="box-content rd-widget widget-{{widgetConfig.widgetId}} widgetSiteInformation widgetNoTopBorder widget-two-columns-one-gap-fifty-percent"
     *ngIf="(widgetData$ | async) as widgetData">
  <div class="table-part">
    <table class="widget-flex" style="height: 100%; table-layout: auto;" aria-hidden="true">
      <thead>
        <tr class="widget-ruller-flex alignCenter red-jll-line ">
          <th scope="col" class="widget-grid-column autoWith">
          </th>
          <th scope="col" class="widget-grid-column autoWith">&nbsp;</th>
          <th scope="col" class="widget-grid-column autoWith">
            {{'dcfLeasingAndRenewalAssumptions.labelVacancies'| rdTranslate}}
          </th>
          <th scope="col" class="widget-grid-column autoWith" *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData; let i = index">
            {{'dcfLeasingAndRenewalAssumptions.labelYear'| rdTranslate }} {{i + 1}}
          </th>
        </tr>
        <tr class="widget-ruller-flex alignCenter red-jll-line">
          <th scope="col" class="widget-grid-column autoWith">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column autoWith" *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData; let i = index">
            {{getStartDate(widgetData.dcfStartDate, i+1) | rdLocalizedDate}}
          </th>
        </tr>
        <tr class="widget-ruller-flex alignCenter red-jll-line">
          <th scope="col" class="widget-grid-column autoWith">&nbsp;</th>
          <th scope="col" class="widget-grid-column autoWith">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column autoWith" *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData; let i = index">
            {{getEndDate(widgetData.dcfStartDate, i+2) |  rdLocalizedDate}}
          </th>
        </tr>
      </thead>
      <tbody class="viewModeTbody">
        <!--Expiry Profile Per Year-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [bold]="true" [fieldName]="'expiryProfilePerYear'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith" style="font-weight: bold">
            <span>{{unitOfArea}}</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line" style="font-weight: bold">
            <span>{{widgetData.tenantAreaVacant|rdLocalizedNumber:2}}</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [bold]="true" [align]="'center'">{{( (data.dcfTenantAreaVacant || 0) |rdLocalizedNumber:2 )}}</widget-value>
          </td>
        </tr>
        <!--Renewal Probaility Per Year-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfRenewalProbalilty'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>%</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>&nbsp;</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{( (data.dcfRenewalProbalilty * 100 || 0) |rdLocalizedNumber:2 )}}%
            </widget-value>
          </td>
        </tr>
        <!--Downtime-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfDowntime'" [align]="'left'"></widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>
              {{'dcfLeasingAndRenewalAssumptions.labelMonths'| rdTranslate}}
            </span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>{{widgetData.reportValuationDowntimeVacancies|rdLocalizedNumber:0}}</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{( (data.dcfDowntime || 0) | rdLocalizedNumber:0 )}}
            </widget-value>
          </td>
        </tr>
        <!--Applied Downtime-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfAppliedDowntime'" [align]="'left'"></widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>
              {{'dcfLeasingAndRenewalAssumptions.labelMonths'|rdTranslate}}
            </span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>{{widgetData.reportValuationAppliedDowntimeVacancies|rdLocalizedNumber:0}}</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{( (data.dcfAppliedDowntime || 0) | rdLocalizedNumber:0 ) }}
            </widget-value>
          </td>
        </tr>
        <!--Lease Term-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfLeaseTerm'" [align]="'left'"></widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>
              {{'dcfLeasingAndRenewalAssumptions.labelYears'| rdTranslate}}
            </span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>{{widgetData.reportValuationLeaseTermVacancies|rdLocalizedNumber:2}}</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{( (data.dcfLeaseTerm || 0) | rdLocalizedNumber:2 )}}
            </widget-value>
          </td>
        </tr>
        <!--commencementProfilePerYear-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [bold]="true" [fieldName]="'labelDcfCommencementProfile'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith" style="font-weight: bold">
            <span>{{unitOfArea}}</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line" style="font-weight: bold">
            <span>{{widgetData.reportValuationCommencementProfile|rdLocalizedNumber:2}}</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [bold]="true" [align]="'center'">
              {{( (data.dcfCommencementProfile || 0) | rdLocalizedNumber:2 ) }}
            </widget-value>
          </td>
        </tr>
        <!--grossIncentivesNewLeasesPerYear-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfGrossIncentivesNewLeases'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>%</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>{{(widgetData.reportValuationGrossIncentivesNewLeases * 100 || 0) |rdLocalizedNumber:2}}</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{( (data.dcfGrossIncentivesNewLeases * 100 || 0) | rdLocalizedNumber:2 )}}%
            </widget-value>
          </td>
        </tr>
        <!--grossIncentivesRenewalsPerYear-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfGrossIncentivesRenewals'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>%</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>&nbsp;</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{  ( (data.dcfGrossIncentivesRenewals * 100 || 0) | rdLocalizedNumber:2 )}}%
            </widget-value>
          </td>
        </tr>
        <!--grossIncentivesPerYear-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfGrossIncentivesVacancies'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>%</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>{{(widgetData.reportValuationGrossIncentivesVacancies * 100 || 0) |rdLocalizedNumber:2}}</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{( (data.dcfGrossIncentivesVacancies * 100 || 0) | rdLocalizedNumber:2 )}}%
            </widget-value>
          </td>
        </tr>
        <!--incentiveProbabilityPerYear-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfIncentiveProbability'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>%</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>{{(widgetData.reportValuationIncentiveProbability * 100 || 0)|rdLocalizedNumber:2}}</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{  ( (data.dcfIncentiveProbability * 100 || 0) | rdLocalizedNumber:2 )}}%
            </widget-value>
          </td>
        </tr>
        <!--appliedGrossIncentivesPerYear-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'dcfAppliedGrossIncentives'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>%</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>{{(widgetData.reportValuationAppliedGrossIncentives * 100 || 0)|rdLocalizedNumber:2}}</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{ ( (data.dcfAppliedGrossIncentives * 100 || 0) | rdLocalizedNumber:2 )}}%
            </widget-value>
          </td>
        </tr>
        <!--appliedIncentivesPerYear-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfAppliedIncentives'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>
              {{'dcfLeasingAndRenewalAssumptions.labelMonths'| rdTranslate}}
            </span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>{{widgetData.reportValuationAppliedIncentives|rdLocalizedNumber:2}}</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{ ( (data.dcfAppliedIncentives || 0) |  rdLocalizedNumber:2 )}}
            </widget-value>
          </td>
        </tr>
        <!--leasingCostsNewLeasesPerYear-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfLeasingCapitalCosts'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>%</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>{{widgetData.reportValuationLeasingCapitalCosts * 100|rdLocalizedNumber:2}}</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{ ( (data.dcfLeasingCapitalCosts * 100 || 0) | rdLocalizedNumber:2 )}}%
            </widget-value>
          </td>
        </tr>
        <!--leasingCostsRenewals-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfLeasingCapitalCostsRenewals'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>%</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>&nbsp;</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{ ( (data.dcfLeasingCapitalCostsRenewals * 100 || 0) | rdLocalizedNumber:2 ) }}%
            </widget-value>
          </td>
        </tr>
        <!--appliedLeasingCostsPerYear-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfAppliedLeasingCosts'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>%</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>{{(widgetData.reportValuationAppliedLeasingCosts * 100)|rdLocalizedNumber:2}}</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{ ( (data.dcfAppliedLeasingCosts * 100 || 0) | rdLocalizedNumber:2 )}}%
            </widget-value>
          </td>
        </tr>
        <!--refurbishmentOnExpiryNewLeasesPerYear-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfRefurbishmentCostsOnExpiryNewLeases'"
                          [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>{{currency}}/{{unitOfArea}}</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>{{widgetData.reportValuationRefurbishmentCostsOnExpiryNewLeases|rdLocalizedNumber:2}}</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{ ( (data.dcfRefurbishmentCostsOnExpiryNewLeases || 0) | rdLocalizedNumber:2 ) }}
            </widget-value>
          </td>
        </tr>
        <!--refurbishmentOnExpiryRenewals-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfRefurbishmentCostsOnExpiryRenewals'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>{{currency}}/{{unitOfArea}}</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>{{widgetData.dcfLeasingAndRenewalAssumptionsYearData|rdLocalizedNumber:2}}</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{( (data.dcfRefurbishmentCostsOnExpiryRenewals || 0) | rdLocalizedNumber:2 )}}
            </widget-value>
          </td>
        </tr>
        <!--allowedRefurbishmentExpiryAllowance-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfAppliedRefurbishmentExpiryAllowance'"
                          [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>{{currency}}/{{unitOfArea}}</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>&nbsp;</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{ ( (data.dcfAppliedRefurbishmentExpiryAllowance || 0) | rdLocalizedNumber:2 )}}
            </widget-value>
          </td>
        </tr>
        <!--netMarketRentStartOfPeriod-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfNetRent'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>{{currency}}/{{unitOfArea}}</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>&nbsp;</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{ ( (data.dcfNetRent || 0) | rdLocalizedNumber:0 )}}
            </widget-value>
          </td>
        </tr>
        <!--grossMarketRentStartOfPeriod-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfGrossRent'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>{{currency}}/{{unitOfArea}}</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>&nbsp;</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{ ( (data.dcfGrossRent || 0) | rdLocalizedNumber:0 )}}
            </widget-value>
          </td>
        </tr>
        <!--occupancyRateWheigthedByArea-->
        <tr class="widget-ruller-flex">
          <td class="widget-grid-column autoWith">
            <widget-label [widget]="this" [fieldName]="'labelDcfOccupancyRateWeightedByArea'" [align]="'left'">
            </widget-label>
          </td>
          <td class="widget-grid-column autoWith">
            <span>%</span>
          </td>
          <td class="widget-grid-column autoWith light-grey-line">
            <span>&nbsp;</span>
          </td>
          <td class="widget-grid-column " *ngFor="let data of widgetData.dcfLeasingAndRenewalAssumptionsYearData">
            <widget-value [align]="'center'">
              {{( (data.dcfOccupancyRateWeightedByArea * 100 || 0) |rdLocalizedNumber:2 )}}%
            </widget-value>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
